import { render, staticRenderFns } from "./WavyLine.vue?vue&type=template&id=10376bdf&scoped=true"
import script from "./WavyLine.vue?vue&type=script&lang=ts"
export * from "./WavyLine.vue?vue&type=script&lang=ts"
import style0 from "./WavyLine.vue?vue&type=style&index=0&id=10376bdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10376bdf",
  null
  
)

export default component.exports